import { render, staticRenderFns } from "./BroadcastPortalEdit.vue?vue&type=template&id=8e2a01e0&scoped=true&"
import script from "./BroadcastPortalEdit.vue?vue&type=script&lang=js&"
export * from "./BroadcastPortalEdit.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastPortalEdit.vue?vue&type=style&index=0&id=8e2a01e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2a01e0",
  null
  
)

export default component.exports